import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-linkedin-icon/jb-linkedin-icon.css.ts
var jb_linkedin_icon_css_default = i`:host{display:block;height:var(--icon-height, 15.3px);width:var(--icon-width, 15.4px)}svg{height:var(--icon-height, 15.3px);width:var(--icon-width, 15.4px)}`;

export {
  jb_linkedin_icon_css_default
};
